

<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="LeaderBoard" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { LeaderBoardProps } from './LeaderBoard.ts';
import LeaderBoard from './LeaderBoard.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-leader-board';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<LeaderBoardProps>();
const changableProps = useChangableProps(componentName, props);

</script>
